"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cast_1 = require("./cast");
const AWSource_1 = require("../types/AWConfig/AWSource/AWSource");
const AWSourceHtml_1 = require("../types/AWConfig/AWSource/AWSourceHtml");
const AWSourceVideo_1 = require("../types/AWConfig/AWSource/AWSourceVideo");
const AWSourceVimeo_1 = require("../types/AWConfig/AWSource/AWSourceVimeo");
const AWSourceVisual_1 = require("../types/AWConfig/AWSource/AWSourceVisual");
const AWSourceAudio_1 = require("../types/AWConfig/AWSource/AWSourceAudio");
function sourceByType(object) {
    switch (object.type) {
        case 'html': return cast_1.castToType(object, AWSourceHtml_1.AWSourceHtml);
        case 'video': return cast_1.castToType(object, AWSourceVideo_1.AWSourceVideo);
        case 'vimeo': return cast_1.castToType(object, AWSourceVimeo_1.AWSourceVimeo);
        case 'image': return cast_1.castToType(object, AWSourceVisual_1.AWSourceVisual);
        case 'audio': return cast_1.castToType(object, AWSourceAudio_1.AWSourceAudio);
        default: return cast_1.castToType(object, AWSource_1.AWSource);
    }
}
exports.sourceByType = sourceByType;
